import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';

const SUBACTION_SELECT_GRID_VIEW = 'select_grid_view';
const SUBACTION_SELECT_LIST_VIEW = 'select_list_view';

const map = {
  lead_form_button: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_PRICING_DETAILS,
    TrackingConstant.VIEW_PRICING_DETAILS
  ),

  view_search_result: TrackingEvent.actionCompleted(
    TrackingConstant.VIEW_SEARCH_RESULT,
    TrackingConstant.VIEW_SEARCH_RESULT
  ),

  view_content: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_CONTENT
  ),

  view_full_program_detail: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_MORE_INFO
  ),

  click_go_to_link: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WEBSITE_CLICKOUT,
    TrackingConstant.OEM_LEASE_OFFER
  ),

  view_full_description: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_DETAILS
  ),

  view_details: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_DETAILS),

  view_details_button: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_DETAILS_BUTTON
  ),

  make_model_year: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ACTION_VIEW_CONTENT
  ),

  lease_deals_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_DISCLAIMER
  ),

  view_review: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.ACTION_VIEW_REVIEW),

  select_grid_view: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, SUBACTION_SELECT_GRID_VIEW),

  select_list_view: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, SUBACTION_SELECT_LIST_VIEW),

  view_filter_section: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_FILTER_SECTION
  ),
  lease_deals_icon_nav_link: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_LEASE_DEALS
  ),
  close_filter_section: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.CLOSE_FILTER_SECTION
  ),

  low_inventory_view_all_specials: overrides =>
    TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.APPLY_FILTER, overrides),
  low_inventory_clear_all_filters: overrides =>
    TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.REMOVE_FILTER, overrides),
  low_inventory_shop_all: overrides =>
    TrackingEvent.actionCompleted(TrackingConstant.VIEW_SEARCH_RESULT, TrackingConstant.VIEW_SEARCH_RESULT, overrides),

  expand_info: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.EXPAND_INFO),

  deal_checker_year_select: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.YEAR_SELECT
  ),
  deal_checker_make_select: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MAKE_SELECT
  ),
  deal_checker_model_select: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MODEL_SELECT
  ),

  deal_checker_input_msrp: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'input_msrp'),
  deal_checker_input_payment: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'input_payment'),
  deal_checker_input_term: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'input_term'),
  deal_checker_input_due_at_signing: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_TOOL_SELECT,
    'input_due_at_signing'
  ),

  deal_checker_submit: TrackingEvent.actionEnd(TrackingConstant.ACTION_SHOW_CONTENT, 'submit_deal_checker'),

  best_vehicle_see_more_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_MORE
  ),

  best_vehicle_see_more_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SEE_MORE
  ),

  inline_article_view_content: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_ARTICLE
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
